import { BridgeAction } from '@omni/kit/Types';
import { EActionHandlers } from '@omni/kit/feeds/ActionHandlerTypes';

interface MediaDetailAction extends BridgeAction {
  handler: EActionHandlers;
}

interface GetMediaDetailActionProps {
  id?: string;
  shortCode?: string;
}

export const getMediaDetailAction = ({
  shortCode = '',
}: GetMediaDetailActionProps): MediaDetailAction => {
  return {
    handler: EActionHandlers.NativeShell,
    moduleCommand: {
      route: `/media/d/${shortCode}`,
    },
  };
};
